/**
* Functionality for home recommendation sections buttons
*/

(function($){
	$(document).ready(function() {
		$('.home_recommendations_section .courses_heading li').on('click', function(event) {
			$('.home_recommendations_section .courses_heading li').removeClass('selected dynamic_background_color');
			$(this).addClass('selected dynamic_background_color');
		});	

		/*
		* Handler for back to top button on mobile
		*/
		$('#rec_back_to_top').on('click', function(event) {
			var offset = $(".home_recommendations_section .courses_heading").offset();
			$("html,body").animate({
    			scrollTop: offset.top,
    			// scrollLeft: offset.left,
    			duration: 'slow'
			});
		});
	});

})(jQuery);